"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Attachment/Image.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _DerivativeImage = require('web/components/Conversation/Message/FileMessage/DerivativeImage'); var _DerivativeImage2 = _interopRequireDefault(_DerivativeImage);
var _ModalView = require('web/components/Conversation/Message/FileMessage/FileImage/ModalView'); var _ModalView2 = _interopRequireDefault(_ModalView);











const AttachmentImage = ({
  blurHash,
  thumbnailUrl,
  width,
  height,
  fileName,
  onRequestFreshThumbnail,
  onRequestOriginal,
}) => {
  const [showingLightbox, setShowingLightbox] = _react.useState.call(void 0, false)
  const [originalUrl, setOriginalUrl] = _react.useState(null)
  const close = () => setShowingLightbox(false)
  const open = () => {
    setShowingLightbox(true)
    if (!originalUrl) onRequestOriginal().then(setOriginalUrl)
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_DerivativeImage2.default, {
        blurHash: blurHash,
        thumbnailUrl: thumbnailUrl,
        width: width,
        height: height,
        fileName: fileName,
        onRequestFreshThumbnail: onRequestFreshThumbnail,
        onOpenOriginal: open, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: showingLightbox,
        fullScreen: true,
        onClose: close,
        className: "file-image--preview-modal",
        bodyClassName: "file-image--preview-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}

        , originalUrl && _react2.default.createElement(_ModalView2.default, {
          imageSrc: originalUrl,
          imageCaption: fileName,
          onClose: close,
          onDownload: () => window.open(originalUrl), __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        )
      )
    )
  )
}

exports. default = AttachmentImage
